import { render, staticRenderFns } from "./sixTextarea.vue?vue&type=template&id=6ea52e3b&scoped=true&"
import script from "./sixTextarea.vue?vue&type=script&lang=js&"
export * from "./sixTextarea.vue?vue&type=script&lang=js&"
import style0 from "./sixTextarea.vue?vue&type=style&index=0&id=6ea52e3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea52e3b",
  null
  
)

export default component.exports